(function (root) {
  "use strict";

  var core = root.SNDTCProductMediaCore;
  if (!core && typeof module !== "undefined" && module.exports) core = require("./product-media-core.js");

  function validConfig(config) {
    return !!(config && /^[a-z0-9][a-z0-9-]*$/.test(config.store_id || "") &&
      /^[a-z0-9.-]+\.[a-z]{2,}$/i.test(config.shopify_domain || "") &&
      /^G-[A-Z0-9]+$/.test(config.ga4_measurement_id || "") &&
      typeof config.analytics_namespace === "string" && config.analytics_namespace.length);
  }

  function createAdapter(options) {
    options = options || {};
    var win = options.window || root;
    var doc = options.document || win.document;
    var config = options.config || win.SNDTCProductMediaConfig;
    var registry = core && core.createMediaRegistry();
    var invalid = !core || !validConfig(config);
    var observer;
    var delegatedClickBound = false;
    var clickDedupe = {};
    var imageVisibility = typeof WeakMap === "function" ? new WeakMap() : new Map();
    var pendingCustomEvents = [];

    function selectors(name) {
      return (config.selectors && config.selectors[name]) || [];
    }
    function all(scope, values) {
      var output = [];
      for (var i = 0; i < values.length; i += 1) {
        var nodes = scope.querySelectorAll(values[i]);
        for (var j = 0; j < nodes.length; j += 1) output.push(nodes[j]);
      }
      return output;
    }
    function roots() {
      return all(doc, selectors("product_roots")).concat(all(doc, selectors("collection_roots")), all(doc, selectors("quick_view_roots")));
    }
    function data(node, key) {
      return node && node.dataset ? node.dataset[key] : undefined;
    }
    function inheritedData(node, key) {
      var current = node;
      while (current && current !== doc && current.dataset) {
        if (current.dataset[key] !== undefined) return current.dataset[key];
        current = current.parentElement;
      }
      return undefined;
    }
    function pageProduct(key) {
      return win.SNDTCPageProduct && win.SNDTCPageProduct[key];
    }
    function mediaUrl(media) {
      var childImage = media.querySelector && media.querySelector("img");
      var childVideo = media.querySelector && media.querySelector("video");
      return inheritedData(media, "snImageUrl") || media.currentSrc || media.src ||
        (childImage && (childImage.currentSrc || childImage.src)) ||
        (childVideo && (childVideo.currentSrc || childVideo.src));
    }
    function fallbackMediaId(media) {
      var url = mediaUrl(media) || "";
      var clean = url.split("?")[0].split("#")[0];
      var explicitMediaId = inheritedData(media, "snMediaId");
      var themeMediaId = inheritedData(media, "mediaId");
      if (explicitMediaId) return explicitMediaId;
      if (themeMediaId) {
        var numericThemeMediaId = String(themeMediaId).match(/(\d+)$/);
        return numericThemeMediaId ? numericThemeMediaId[1] : String(themeMediaId);
      }
      return clean.split("/").filter(Boolean).pop() || undefined;
    }
    function mediaContext(node, media) {
      var url = mediaUrl(media);
      var childImage = media.querySelector && media.querySelector("img");
      var childVideo = media.querySelector && media.querySelector("video");
      var inferredType = childVideo ? "video" : childImage ? "image" : (media.tagName || "image").toLowerCase();
      return {
        store_id: config.store_id,
        shopify_domain: config.shopify_domain,
        page_type: config.page_type || "product",
        product_id: data(node, "snProductId") || pageProduct("product_id"), product_handle: data(node, "snProductHandle") || pageProduct("product_handle"), variant_id: data(node, "snVariantId") || pageProduct("variant_id"),
        media_id: fallbackMediaId(media), media_type: inheritedData(media, "snMediaType") || inferredType,
        media_position: Number(inheritedData(media, "snMediaPosition")) || undefined,
        image_url: url,
      };
    }
    function viewportVisibilityRatio(media) {
      if (!media || typeof media.getBoundingClientRect !== "function" || !win || !win.innerWidth || !win.innerHeight) return 0;
      var rect = media.getBoundingClientRect();
      var width = Math.max(0, Number(rect.width) || (rect.right - rect.left) || 0);
      var height = Math.max(0, Number(rect.height) || (rect.bottom - rect.top) || 0);
      if (!width || !height) return 0;
      var visibleWidth = Math.max(0, Math.min(rect.right, win.innerWidth) - Math.max(rect.left, 0));
      var visibleHeight = Math.max(0, Math.min(rect.bottom, win.innerHeight) - Math.max(rect.top, 0));
      return (visibleWidth * visibleHeight) / (width * height);
    }
    function publishClarity(name, envelope) {
      if (typeof win.clarity !== "function") return;
      var properties = envelope.properties || {};
      var tags = { sn_event: name, sn_event_id: envelope.event_id, sn_store: envelope.store_id, sn_product: properties.product_id, sn_media: properties.media_id, sn_media_type: properties.media_type, sn_video_progress: properties.progress_percent, sn_video_watch_msec: properties.watch_time_msec };
      for (var key in tags) if (tags[key] !== undefined) win.clarity("set", key, String(tags[key]));
    }
    function flushCustomEvents(attempt) {
      if (!pendingCustomEvents.length) return;
      if (win.SNDTC && typeof win.SNDTC.emitCustom === "function") {
        var pending = pendingCustomEvents;
        pendingCustomEvents = [];
        for (var i = 0; i < pending.length; i += 1) {
          pending[i].result = win.SNDTC.emitCustom(pending[i].name, pending[i].properties);
          if (pending[i].result && pending[i].result.envelope) pending[i].onDelivered(pending[i].result.envelope);
        }
        return;
      }
      if ((win.__snConsent && win.__snConsent.analytics === false) || attempt >= 20) {
        pendingCustomEvents = [];
        return;
      }
      win.setTimeout(function () { flushCustomEvents(attempt + 1); }, 250);
    }
    function emitCustom(name, properties, onDelivered) {
      if (win.SNDTC && typeof win.SNDTC.emitCustom === "function") {
        var result = win.SNDTC.emitCustom(name, properties);
        if (result && result.envelope) onDelivered(result.envelope);
        return result;
      }
      if (win.__snConsent && win.__snConsent.analytics === false) return;
      pendingCustomEvents.push({ name: name, properties: properties, onDelivered: onDelivered });
      if (pendingCustomEvents.length === 1) flushCustomEvents(0);
    }
    function projectCanonicalEvent(name, envelope) {
      var properties = envelope.properties || {};
      var auditEnvelope = Object.assign({ event: name }, envelope, properties);
      delete auditEnvelope.properties;
      // shopify_shop is retained only in local audit projections for legacy consumers.
      auditEnvelope.shopify_shop = envelope.shopify_domain;
      publishClarity(name, envelope);
      return auditEnvelope;
    }
    function publish(name, params) {
      var projected;
      var result = emitCustom(name, Object.assign({}, params), function (envelope) {
        projected = projectCanonicalEvent(name, envelope);
      });
      return projected || (result && result.envelope) || undefined;
    }
    function mediaKey(context) {
      return core.logicalMediaKey({ productId: context.product_id, mediaId: context.media_id, mediaUrl: context.image_url, context: data(context.root, "snContext") || "pdp" });
    }
    function matchesAny(node, values) {
      if (!node || typeof node.matches !== "function") return false;
      for (var i = 0; i < values.length; i += 1) {
        try {
          if (node.matches(values[i])) return true;
        } catch (error) {}
      }
      return false;
    }
    function rootFor(media) {
      var current = media && media.parentElement;
      while (current && current !== doc) {
        if (matchesAny(current, selectors("product_roots")) || matchesAny(current, selectors("collection_roots")) || matchesAny(current, selectors("quick_view_roots"))) return current;
        current = current.parentElement;
      }
      return undefined;
    }
    function mediaForClick(target) {
      var current = target && target.nodeType === 3 ? target.parentElement : target;
      while (current && current !== doc) {
        if (matchesAny(current, selectors("media_nodes")) || matchesAny(current, selectors("thumbnail_nodes"))) {
          var rootNode = rootFor(current);
          if (rootNode) return { root: rootNode, media: current };
        }
        current = current.parentElement;
      }
      return undefined;
    }
    function mainMediaForThumbnail(rootNode, thumbnail) {
      var thumbnailMediaId = fallbackMediaId(thumbnail);
      if (!thumbnailMediaId || !rootNode || typeof rootNode.querySelectorAll !== "function") return thumbnail;
      var selectorsToCheck = selectors("media_nodes");
      for (var selectorIndex = 0; selectorIndex < selectorsToCheck.length; selectorIndex += 1) {
        var candidates;
        try {
          candidates = rootNode.querySelectorAll(selectorsToCheck[selectorIndex]);
        } catch (error) {
          candidates = [];
        }
        for (var candidateIndex = 0; candidateIndex < candidates.length; candidateIndex += 1) {
          var candidate = candidates[candidateIndex];
          if (candidate !== thumbnail && fallbackMediaId(candidate) === thumbnailMediaId) return candidate;
        }
      }
      return thumbnail;
    }
    function handleMediaClick(rootNode, media, event) {
      if (!event || (!event.pointerType && event.type !== "keydown" && event.type !== "click")) return;
      var isThumbnail = matchesAny(media, selectors("thumbnail_nodes"));
      var sourceMedia = isThumbnail ? mainMediaForThumbnail(rootNode, media) : media;
      var context = mediaContext(rootNode, sourceMedia);
      context.root = rootNode;
      var key = mediaKey(context);
      delete context.root;
      var isVideo = (context.media_type || "").toLowerCase() === "video" || (sourceMedia.tagName || "").toLowerCase() === "video";
      var now = Date.now();
      if (clickDedupe[key] && now - clickDedupe[key] < 500) return;
      clickDedupe[key] = now;
      var clickTarget = event.target && inheritedData(event.target, "snClickTarget");
      publish(isVideo ? "product_video_clicked" : "product_image_clicked", Object.assign({ click_target: clickTarget || (isThumbnail ? "thumbnail" : data(media, "snClickTarget")) || (isVideo ? "pdp_video" : "main_image") }, context));
    }
    function bindDelegatedClick() {
      if (delegatedClickBound || !doc || typeof doc.addEventListener !== "function") return;
      delegatedClickBound = true;
      doc.addEventListener("click", function (event) {
        var match = mediaForClick(event && event.target);
        if (match) handleMediaClick(match.root, match.media, event);
      }, true);
    }
    function bindVideo(rootNode, media, context) {
      if (media.__snProductMediaVideoBound) return;
      media.__snProductMediaVideoBound = true;
      var session = core.createVideoSession({ durationSeconds: Number(media.duration) || 0, emit: function (event) { publish(event.name, Object.assign({}, context, event)); } });
      media.addEventListener("play", function () { session.onPlay(Date.now()); });
      media.addEventListener("pause", function () { session.onPause(Date.now()); });
      media.addEventListener("timeupdate", function () { session.onTimeUpdate(media.currentTime, Date.now()); });
      media.addEventListener("seeked", function () { session.onSeeked(media.currentTime, Date.now()); });
      media.addEventListener("ended", function () { session.onEnded(Date.now()); });
      if (doc && typeof doc.addEventListener === "function") {
        doc.addEventListener("visibilitychange", function () {
          if (doc.hidden) session.onPageHidden(Date.now(), "page_hidden");
        });
      }
      if (win && typeof win.addEventListener === "function") win.addEventListener("pagehide", function () { session.onPageHidden(Date.now(), "pagehide"); });
      if (typeof win.IntersectionObserver === "function") new win.IntersectionObserver(function (entries) { for (var i = 0; i < entries.length; i += 1) session.onVisibility(entries[i].intersectionRatio, Date.now()); }, { threshold: [0, 0.5] }).observe(media);
    }
    function bindMedia(rootNode, media) {
      if (media.getAttribute && media.getAttribute("data-sn-product-media-bound") === "true") return;
      if (media.setAttribute) media.setAttribute("data-sn-product-media-bound", "true");
      var context = mediaContext(rootNode, media);
      context.root = rootNode;
      var key = mediaKey(context);
      delete context.root;
      var isVideo = (context.media_type || "").toLowerCase() === "video" || (media.tagName || "").toLowerCase() === "video";
      var visibility = { visible: false, ratio: 0, timer: null };
      imageVisibility.set(media, visibility);
      function cancelVisibility(state) {
        if (state.timer) win.clearTimeout(state.timer);
        state.timer = null;
      }
      function scheduleVisibility(state, ratio) {
        state.visible = ratio >= 0.5;
        state.ratio = Math.round(ratio * 100);
        if (!state.visible) {
          cancelVisibility(state);
          return;
        }
        if (state.timer || registry.hasViewed(key)) return;
        state.timer = win.setTimeout(function () {
          state.timer = null;
          if (state.visible && registry.markViewed(key)) publish(isVideo ? "product_video_visible" : "product_image_viewed", Object.assign({ view_method: "visible_50pct_1s", visibility_ratio: state.ratio }, context));
        }, 1000);
      }
      if (typeof win.IntersectionObserver === "function") {
        new win.IntersectionObserver(function (entries) {
          for (var entryIndex = 0; entryIndex < entries.length; entryIndex += 1) {
            var entry = entries[entryIndex];
            var state = imageVisibility.get(entry.target);
            if (!state) continue;
            scheduleVisibility(state, entry.intersectionRatio);
          }
        }, { threshold: [0, 0.5] }).observe(media);
      }
      function syncCarouselActiveVisibility() {
        if (!media.classList || !media.classList.contains("is-active")) return;
        scheduleVisibility(visibility, viewportVisibilityRatio(media));
        // Carousel libraries often toggle the active class before their transform
        // finishes. Recheck after the transition frame so a real active slide can
        // still satisfy the same 50%-visible-for-1s rule.
        win.setTimeout(function () { scheduleVisibility(visibility, viewportVisibilityRatio(media)); }, 300);
      }
      syncCarouselActiveVisibility();
      if (typeof win.MutationObserver === "function") {
        new win.MutationObserver(syncCarouselActiveVisibility).observe(media, { attributes: true, attributeFilter: ["class"] });
      }
      media.addEventListener("click", function (event) {
        handleMediaClick(rootNode, media, event);
      }, true);
      if ((context.media_type || "").toLowerCase() === "video" || (media.tagName || "").toLowerCase() === "video") bindVideo(rootNode, media, context);
      var childVideo = media.querySelector && media.querySelector("video");
      if (childVideo && childVideo !== media) {
        var childContext = mediaContext(rootNode, childVideo);
        childContext.media_type = "video";
        bindVideo(rootNode, childVideo, childContext);
      }
    }
    function scan() {
      if (invalid) return;
      var configuredRoots = roots();
      for (var i = 0; i < configuredRoots.length; i += 1) {
        var nodes = all(configuredRoots[i], selectors("media_nodes"));
        for (var j = 0; j < nodes.length; j += 1) bindMedia(configuredRoots[i], nodes[j]);
      }
    }
    function start() {
      if (invalid) {
        if (win.console && typeof win.console.error === "function") win.console.error("[SNDTC] product media disabled: invalid store configuration");
        return false;
      }
      scan();
      bindDelegatedClick();
      if (typeof win.MutationObserver === "function" && !observer) {
        observer = new win.MutationObserver(scan);
        observer.observe(doc.documentElement || doc.body, { childList: true, subtree: true });
      }
      return true;
    }
    return { start: start, scan: scan, publish: publish, valid: function () { return !invalid; } };
  }

  var api = { createAdapter: createAdapter, validConfig: validConfig };
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  root.SNDTCProductMediaAnalytics = api;
})(typeof globalThis !== "undefined" ? globalThis : this);
